import analyticService from "@/services/analytic.service.js"

export const Analytics = {
	namespaced : true,
	state :{
		list: [
			{ name : 'objects',},
			{ name :  'lpr',}, 
			{ name : 'face',  },
			// { name : 'anomalies',  },
			{ name : 'actions',  },
			{ name : 'motion',  },
			{ name : 'smart_event',  },
			{ name : 'avc',  },
			{ name : 'data',} ,
		],
		isLoaded : false,
	},
	getters:{
		getList: (state)=> {
	        return state.list;
	    },
	    getIsLoaded: (state)=>{
	    	return state.isLoaded;
	    }
	},
	actions:{
		getList({commit}){
			// console.log("LIST ", analyticService)
			analyticService.getListFor(1).then(res=>{
				// console.log("Finish get list for face ", res)
				commit("setList",res)
				commit("setIsLoaded",true)

			}).catch(erro=>{
				console.warn("Error get list analytic ", error)
			});
		}
	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	    setIsLoaded(state, val){
	    	state.isLoaded=val;
	    }
	},
}